import React from 'react';

export default (props: any) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect x="3" y="3" width="18" height="18" rx="4" strokeLinejoin="round" />
    <path d="M16 8L8 16" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M8 8L16 16" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);
